import { getRaw, hasRaw } from './raw'

function plainRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined
  }
  return value as Record<string, unknown>
}

/** Rebuild `source` through `factory`, keeping the stored payload and applying `knownEdits`. */
export function editPreservingUnknown<T extends object>(
  source: T,
  knownEdits: Record<string, unknown>,
  factory: (json: Record<string, unknown>) => T
): T {
  const raw = hasRaw(source) ? plainRecord(getRaw(source)) : undefined
  const toJson = (source as { toJSON?: () => unknown }).toJSON
  const serialized = raw ?? (typeof toJson === 'function' ? toJson.call(source) : {})
  return factory({ ...(plainRecord(serialized) ?? {}), ...knownEdits })
}
